var render, staticRenderFns
import script from "./table.vue?vue&type=script&lang=js&"
export * from "./table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\gw-actions-runner\\_work\\gower-web-core\\gower-web-core\\App.Core.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('566da312')) {
      api.createRecord('566da312', component.options)
    } else {
      api.reload('566da312', component.options)
    }
    
  }
}
component.options.__file = "scripts/components/generic/table.vue"
export default component.exports